// extracted by css-extract-rspack-plugin
export default {"dashedButton":"SharedEmptyPicker-module__dashedButton__OawCs","hotkeyBadge":"SharedEmptyPicker-module__hotkeyBadge__rfFM2"};